export default ({ request }) => ({
  ecomAmzMarketListApi(data = {}) {
    return request({
      url: '/ecom/amz/market/list',
      method: 'post',
      data,
    })
  },
  ecomAmzMarketDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/market/detail',
      method: 'post',
      data,
    })
  },
  ecomAmzMarketSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/market/save',
      method: 'post',
      data,
    })
  },
  ecomAmzMarketDelApi(data = {}) {
    return request({
      url: '/ecom/amz/market/del',
      method: 'post',
      data,
    })
  },
})
